module.exports = __webpack_public_path__ + "static/typography-2-d28771958fc2d29a5a9d3139a2ed1205.png";